module.exports = __webpack_public_path__ + "media/arek2.8ea148fa.mp3";